import {BorderArticle} from "@ui/general/BorderArticle";
import {RootIcon} from "@ui/icons/RootIcon";
import {useSelector} from "react-redux";
import {Link} from "react-router-dom";

import styles from "./styles.module.scss";

export const TableButton = ({
  title,
  icon,
  color,
  label,
  action,
  onClickAction,
  item,
  disabled,
}) => {
  const {isMobile} = useSelector((state) => state.common.settings);

  const isActionLink =
    action !== "deactivate" &&
    action !== "activate" &&
    action !== "delete" &&
    action !== "item";

  const isActionButton =
    action === "deactivate" ||
    action === "activate" ||
    action === "delete" ||
    action === "item";

  return (
    <div
      title={title}
      className={
        disabled
          ? `${styles.tableButton} ${styles.tableButtonDis}`
          : styles.tableButton
      }
      style={
        title
          ? {cursor: "default"}
          : disabled
            ? {cursor: "default"}
            : {cursor: "pointer"}
      }
    >
      <Link
        to={
          disabled
            ? undefined
            : isActionLink
              ? `${action}/${item.id}`
              : undefined
        }
        onClick={
          disabled ? undefined : isActionButton ? onClickAction : undefined
        }
        style={{
          "borderColor": color || "var(--black)",
          "color": color || "inherit",
          "--color": color || "transparent",
        }}
      >
        {icon && (
          <RootIcon
            width={isMobile ? 30 : 16}
            height={isMobile ? 30 : 16}
            id={icon}
            disabled={disabled}
          />
        )}
      </Link>

      <BorderArticle>
        <i>{label}</i>
      </BorderArticle>
    </div>
  );
};
